module.exports = __webpack_public_path__ + "img/7.d20e19d8.webp";